module.exports = __webpack_public_path__ + "img/factory.f967aff8.png";